module.exports = __webpack_public_path__ + "static/media/bg_register.df019df9.jpg";